import { LISTING_STATUS } from '../constants/listingStatus';
import { findListingEntity } from './entityReadHelpers';
import { upsertListing, upsertListingVariant } from './entityAdapter';
import { setActiveTabByProductChannel } from './uiAdapter';

export const applyCreateDraftResult = (state, {
  productId,
  channelId,
  listing,
  variants = [],
}) => {
  if (!listing) return;

  const existingListing = findListingEntity(state, { masterProductId: productId, channelId });

  const hasDraftVariants = variants.some(
    (variant) => variant.listingStatus === LISTING_STATUS.DRAFT,
  );
  const listingStatus = listing.listingStatus === LISTING_STATUS.DRAFT || hasDraftVariants
    ? LISTING_STATUS.DRAFT
    : listing.listingStatus;

  setActiveTabByProductChannel(state, productId, channelId, listingStatus);

  upsertListing(state, {
    ...(existingListing || {}),
    ...listing,
    listingStatus,
    masterProductId: productId,
  });

  variants.forEach((variant) => {
    upsertListingVariant(state, variant);
  });
};
